/** Заставка на время входа и загрузки дня. */
export function Splash() {
  return (
    <div className="splash">
      <img src="/logo-full.svg" alt="Cora" />
      <div className="splash-dots" aria-label="Загрузка">
        <i />
        <i />
        <i />
      </div>
    </div>
  );
}
